import React, {Fragment, useState} from "react";
import {useDispatch} from "react-redux";
import CommonHeader from "../../components/Headers/CommonHeader";
import AddInventory from "../../components/Modal/AddInventory";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/ProtectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {
  simDropdown,
  storeEditInventoryData,
  systemProfile,
} from "../../redux/Actions/inventory.actions";
import InventoryTable from "./inventoryTable";

const InventoryComponent = () => {
  const [modalOpen, toggleModal] = useState(false);
  const dispatch = useDispatch();

  const modalHandler = () => {
    dispatch(storeEditInventoryData({}));
    dispatch(simDropdown());
    dispatch(systemProfile());
    toggleModal(true);
  };
  return (
    <SafeView>
      <ProtectedContent perms={["view_systeminventory"]} showFallback>
        <Fragment>
          {modalOpen && (
            <AddInventory
              open={modalOpen}
              onClose={() => toggleModal(false)}
              onCancel={toggleModal}
              onEdit={false}
            />
          )}
          <ProtectedContent perms={["add_systeminventory"]}>
            <CommonHeader
              content={"Add Inventory"}
              handleAddClick={modalHandler}
              testID={"add_inventory"}
            />
          </ProtectedContent>
          <div className="table-container">
            <InventoryTable />
          </div>
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const Inventory = () => {
  return (
    <PageURLContextProvider>
      <InventoryComponent />
    </PageURLContextProvider>
  );
};

export default Inventory;
